// extracted by mini-css-extract-plugin
module.exports = {"popup-container":"warningOverlay_popup-container__2QJB0","popup-content":"warningOverlay_popup-content__2JyeA","popup-background":"warningOverlay_popup-background__2HHmz"};